import axios from 'axios';
import qs from 'qs';
// import { Message } from 'element-ui';

axios.defaults.timeout = 15000;
axios.defaults.baseURL ='';
// axios.interceptors.request.use((config) => {
//   // store.commit('updateLoadingStatus', true)
//   if (config.method === 'post' && axios.defaults.headers.post['Content-Type'] === 'multipart/form-data;') {
//     return config
//   }
//   // if (config.method === 'post' && axios.defaults.headers.post['Content-Type'] === 'application/x-www-form-urlencoded') {
//   //   config.data = JSON.stringify(config.data)
//   // } else {
//   //   config.data = JSON.stringify(config.data)
//   // }
//   return config
//
// }, (error) => {
//   return Promise.reject(error)
// })


axios.interceptors.request.use((config) => {
  // store.commit('updateLoadingStatus', true)
  if(config.msg==1){    //1为上传图片
    config.headers['Content-Type'] = 'multipart/form-data';
    // config.data=q
    return config
    // if (config.method === 'post' && axios.defaults.headers.post['Content-Type'] === 'multipart/form-data;') {
    //   return config
    // }
  }else {
    config.headers['Content-Type']= 'application/x-www-form-urlencoded'
  if (config.method === 'post' && axios.defaults.headers.post['Content-Type'] === 'application/x-www-form-urlencoded'){
      config.data = qs.stringify(config.data)
      // return config

  }else {
      config.data = JSON.stringify(config.data)
    }
  }

  return config

}, (error) => {
  return Promise.reject(error)
})


// http request 拦截器
// axios.interceptors.request.use(
//   config => {
//     const params = new URLSearchParams()
//     for (const key in config.data) {
//       if (config.data.hasOwnProperty(key)) {
//         params.append(key, config.data[key])
//       }
//     }
//     config.data = params    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
//     // config.data = JSON.stringify(config.data);
//     // config.data = JSON.parse(config.data);
//     // if (config.method === 'post' && axios.defaults.headers.post['Content-Type'] === 'multipart/form-data;') {
//     //   return config
//     // }
//     config.headers = {
//       // 'Content-Type':'multipart/form-data'
//       'Content-Type':'application/x-www-form-urlencoded'
//     }
//     // config.headers = {
//     //   'Content-Type':'application/x-www-form-urlencoded'
//     // }
//     // if(token){
//     //   config.params = {'token':token}
//     // }
//     return config;
//   },
//   error => {
//     return Promise.reject(err);
//   }
// );


//http response 拦截器
// axios.interceptors.response.use(
//   response => {
//     // if(response.data.errCode ==2){
//     //   router.push({
//     //     path:"/login",
//     //     querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
//     //   })
//     // }
//     return response;
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data = {}){
  // console.log(typeof data,data)
      // let data=JSON.parse(data)
  // let aaa=JSON.parse(data)
  return new Promise((resolve,reject) => {

    // let aaa=JSON.parse(data)
    // var a={'Content-Type':'multipart/form-data'}
    axios.post(url,data)
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}





// WEBPACK FOOTER //
// ./src/utils/https/https.js